import { useMemo } from "react";
import axios from "axios";
import useAuthService from "../hooks/useAuthService";
import { API_URL } from "./apiConfig";

const useAxiosInstance = (navigate) => {
    const { refreshAccessToken } = useAuthService();

    const axiosInstance = useMemo(() => {
        const instance = axios.create({
            baseURL: API_URL,
        });

        instance.interceptors.request.use(
            async (config) => {
                const accessExpiry = localStorage.getItem("access_token_expiry");

                if (accessExpiry && Date.now() > Number(accessExpiry)) {
                    // Use navigate to handle redirection after refreshing the token
                    await refreshAccessToken(navigate);
                }

                const token = localStorage.getItem("access_token");
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }

                return config;
            },
            (error) => Promise.reject(error)
        );

        return instance;
    }, [navigate, refreshAccessToken]);

    return axiosInstance;
};

export default useAxiosInstance;